import { useLanguage } from "../hooks/useLanguage"
import { Check, Lock } from "./icons"

const badge = "rounded-full px-3 py-[6px] font-mono text-[12.5px]"
const stepNumber = "text-[36px] font-semibold leading-none tracking-[-0.05em]"
const stepTitle = "mt-2 text-[26px] font-semibold tracking-[-0.035em]"
const stepCard = "gms-tile flex min-h-[520px] flex-col gap-[14px] rounded-tile p-8"
const mockCard = "mt-auto rounded-card p-[18px]"
const statusPill = "rounded-full py-[3px] font-mono text-[11px]"

export default function Process() {
  const { t } = useLanguage()
  const p = t.process
  const { scope, build, launch } = p

  return (
    <section id="processo" className="gms-wrap pt-section">
      <div className="flex flex-wrap items-end justify-between gap-x-16 gap-y-6">
        <div className="min-w-0 max-w-[820px] flex-[1_1_560px]">
          <div className="gms-eyebrow">{p.eyebrow}</div>
          <h2 className="gms-h2">{p.title}</h2>
        </div>
        <p className="flex-[0_1_400px] text-[17px] leading-[1.55] text-gms-muted">{p.lead}</p>
      </div>

      <div className="mt-14 grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(min(340px,100%),1fr))]">
        <article className={`${stepCard} bg-gms-mist`}>
          <div className="flex items-center justify-between gap-3">
            <span className={`${badge} border border-gms-line bg-white`}>{scope.badge}</span>
            <span aria-hidden="true" className={`${stepNumber} text-gms-line-2`}>01</span>
          </div>
          <h3 className={stepTitle}>{scope.title}</h3>
          <p className="text-[16px] leading-[1.55] text-gms-muted">{scope.text}</p>
          <div aria-hidden="true" className={`${mockCard} border border-gms-line bg-white shadow-[0_20px_40px_-24px_rgba(11,13,18,0.25)]`}>
            <div className="flex items-center justify-between gap-3">
              <span className="text-[15px] font-semibold">{scope.card}</span>
              <span className={`${statusPill} px-2 bg-gms-accent-soft text-gms-accent`}>{scope.status}</span>
            </div>
            <div className="mt-[14px] flex flex-col gap-[10px] text-[14px]">
              {scope.rows.map(({ k, v }) => (
                <div key={k} className="flex justify-between gap-3 border-b border-gms-line-soft pb-[10px]">
                  <span className="text-gms-subtle">{k}</span>
                  <span className="font-medium">{v}</span>
                </div>
              ))}
              <div className="flex items-center justify-between gap-3">
                <span className="text-gms-subtle">{scope.priceLabel}</span>
                <span className="inline-flex items-center gap-[6px] font-medium">
                  <Lock size={13} />
                  {scope.priceValue}
                </span>
              </div>
            </div>
          </div>
        </article>

        <article className={`${stepCard} bg-gms-mist`}>
          <div className="flex items-center justify-between gap-3">
            <span className={`${badge} border border-gms-line bg-white`}>{build.badge}</span>
            <span aria-hidden="true" className={`${stepNumber} text-gms-line-2`}>02</span>
          </div>
          <h3 className={stepTitle}>{build.title}</h3>
          <p className="text-[16px] leading-[1.55] text-gms-muted">{build.text}</p>
          <div aria-hidden="true" className={`${mockCard} border border-gms-line bg-white shadow-[0_20px_40px_-24px_rgba(11,13,18,0.25)]`}>
            <div className="flex items-center justify-between gap-3">
              <span className="text-[15px] font-semibold">{build.card}</span>
              <span className={`${statusPill} px-2 bg-gms-ink text-white`}>{build.status}</span>
            </div>
            <div className="mt-[14px] flex flex-col gap-[10px] text-[14px]">
              {build.done.map((item) => (
                <div key={item} className="flex items-center gap-[10px]">
                  <span className="inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-gms-accent text-white">
                    <Check size={11} strokeWidth={3.2} />
                  </span>
                  {item}
                </div>
              ))}
              <div className="flex items-center gap-[10px] text-gms-subtle">
                <span className="h-5 w-5 flex-none rounded-full border-2 border-dashed border-[#C4C4CC]" />
                {build.pending}
              </div>
            </div>
          </div>
        </article>

        <article className={`${stepCard} bg-gms-ink text-white`}>
          <div className="flex items-center justify-between gap-3">
            <span className={`${badge} border border-gms-dark-line-2 text-gms-dark-text`}>{launch.badge}</span>
            <span aria-hidden="true" className={`${stepNumber} text-gms-dark-line-2`}>03</span>
          </div>
          <h3 className={stepTitle}>{launch.title}</h3>
          <p className="text-[16px] leading-[1.55] text-gms-dark-body">{launch.text}</p>
          <div aria-hidden="true" className={`${mockCard} border border-gms-dark-edge bg-gms-dark-1`}>
            <div className="flex items-center justify-between gap-3">
              <span className="text-[15px] font-semibold">{launch.card}</span>
              <span className={`${statusPill} inline-flex items-center gap-[6px] bg-[rgba(61,220,151,0.12)] px-[9px] text-gms-mint`}>
                <span className="gms-live h-[6px] w-[6px] rounded-full bg-gms-live" />
                {launch.status}
              </span>
            </div>
            <div className="mt-[14px] flex flex-col gap-[10px] text-[14px] text-gms-dark-fg">
              {launch.done.map((item) => (
                <div key={item} className="flex items-center gap-[10px]">
                  <Check size={16} className="flex-none text-gms-accent-on-dark" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </article>
      </div>
    </section>
  )
}
